<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch02">
<a id="page3"></a>
<div class="chapterHead">
<h2 class="chapterNumber"><span class="xrefInternal"><a href="#/xhtml/contents#ch_02"><span class="bold"><span class="smallCaps">TWO</span></span></a></span></h2>
<h2 class="chapterTitle"><span class="xrefInternal"><span class="bold"><em class="italic">Mobile Bay</em></span></span></h2>
</div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="smallCaps">ALL DAY THERE IS A SLIGHT BREEZE FROM THE EAST. FLAGS ON</span> the Harlow community pier stir, even ripple at times; washing dries on clotheslines strung between pecans and live oaks. Soon towels and sheets, stiff, smelling of soap, Mobile Bay, and August will be folded and put into linen closets. Out on the bay, brown pelicans skim the water.</p>
<p class="para">And all day the people who live around the bay watch the water. They walk to the edge and dip their hands into the small warm waves that wash against the beach. They cup their hands around their eyes and look across the gray-green surface. Nothing. “But it’s a full moon tonight,” they agree. And they get their baskets and seines ready.</p>
<p class="para">In Harlow, after dark, they put a watchman on the pier, but he is not needed. Even before his first shout of “Jubilee!” people are running to watch the fish slice the water’s skin with their serrated, glistening fins, running to see the water whorl as the fish glide past each other, circling into the shallows toward the beach.</p>
<a id="page4"></a>
<p class="para">“Here they come!”</p>
<p class="para">“Jubilee!”</p>
<p class="para">“Would you look at that!”</p>
<p class="para">“Jubilee! Jubilee!” sing the fishermen to the millions of moons in the bay.</p>
<p class="para">“Jubilee! Jubilee!” Artie Sullivan hears. Then she clutches her sheet and dies.</p>
<p class="para">Mrs. Randolph, the sitter, rushes to get buckets and a flashlight from the back porch so she can join the other Harlow residents who are already gathering fish, crabs, and shrimp that are silvering the beach like a wave. “Jubilee! Jubilee!” echoes across the bay.</p>
<p class="para">“I knew it,” Mrs. Randolph calls to the next-door neighbor who is running across the lawn carrying a net. “You could just tell the wind was right.”</p>
<p class="para">“Gumbo tomorrow!” the woman answers. “Come help me hold the net.”</p>
<p class="para">“Gumbo for everybody!” Mrs. Randolph hurries down the steep narrow path to the beach.</p>
<p class="para">“Jubilee! Jubilee!” everyone sings before excited laughter becomes the silence of concentration, of choosing the choicest bounty. And even as they fill their buckets, more fish and crabs rise to the beach. Nets and buckets grow heavy.</p>
<p class="para">“I never have understood why they do it,” Mrs. Randolph says, picking crabs carefully from the net.</p>
<p class="para">“Why they come to the beach? Something to do with the oxygen in the water.” Both women suddenly remember how the beach will smell in a couple of days, how they will have to rake the fish carcasses into piles and pay the garbage men extra to carry the mess away. And the flies! Mrs. Randolph is thinking how impossible it is to get all the shells out of crabmeat. Even in the best restaurants you get shells. At a dear price, too.</p>
<a id="page5"></a>
<p class="para">By the time Mrs. Randolph returns to the house, slightly out of breath and with her neck aching, Artie is definitely dead.</p>
<p class="para">For a moment, Mrs. Randolph is startled. But only for a moment. Then she straightens Artie’s head on the pillow, goes to call Donnie and Father Carroll and find the crab boil.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?40f41fd7